import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore/mapFirestoreDocWithTimestamp';
import {ProgressDb} from './progressDbSchema';
import {Progress, progressSchema} from './progressSchema';

/**
 * Map a Firestore progress document snapshot to Progress (id from document id, lastUpdated as Date).
 */
export function mapProgressDbToType(db: FirestoreDocSnapshotWithIdAndData<ProgressDb>): Progress {
  const data = mapFirestoreDocWithTimestamp(db);
  return progressSchema.parse(data);
}
